import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalVariable } from '../_helpers/localvariable'
import { tap, catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-strava',
  templateUrl: './strava.component.html',
  styleUrls: ['./strava.component.css']
})
export class StravaComponent implements OnInit {

  error = false;
  constructor(private activatedRoute: ActivatedRoute, private router: Router, private http: HttpClient) { }

  ngOnInit(): void {
    this.authStrava();
    
  }

  async authStrava(){
    let scope = this.activatedRoute.snapshot.queryParamMap.get('scope');
    let code = this.activatedRoute.snapshot.queryParamMap.get('code');
    let state = this.activatedRoute.snapshot.queryParamMap.get('state');

    let req = {
      "scope" : scope,
      "code": code,
      "state": state,
      "token": localStorage.getItem("maplerace_auth")
    }

    await this.http.post(environment.endpoint + "/strava/auth", req, {responseType: 'text'}).toPromise().then(value => {
      localStorage.setItem("maplerace_stravaConnect", "true");
      let redirect =  '/dashboard';
      this.router.navigateByUrl(redirect);
    }).catch((error) => {
      this.error = true;
    });

  }

}
